// ESM-Huelle um lib/scripts/pos/netcomm/CLS_CServerInterface.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
//******************************************************************************
// CServerInterface
//******************************************************************************
// Description:
//      Listens on incoming socket connections and handles incoming and outgoing
//      streams.
//******************************************************************************

// *** Constructor ***
function CServerInterface (dataCallback)
{
    this.dataCallback = dataCallback;
}
// ***

// *** Class variables ***
CServerInterface.prototype.dataCallback = null;
CServerInterface.prototype.outputStream = null;
CServerInterface.prototype.inputStream = null;
// ***

// *** Class methods ***
//------------------------------------------------------------------------------
// Description:
//      Runs when a new socket connection is made. Initializes an input and
//      output stream.
//------------------------------------------------------------------------------
CServerInterface.prototype.onSocketAccepted = function (socket, transport)
{
    /*privMan.enablePrivilege (privList);*/
//    snake.addTransport (transport);

    this.outputStream = new COutputStream (transport);
    this.inputStream = new CInputStream (transport, this.dataCallback);
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Runs when a socket connection is closed - does nothing for now.
//------------------------------------------------------------------------------
CServerInterface.prototype.onStopListening = function (socket, status) {}
//------------------------------------------------------------------------------
// ***
CServerInterface.prototype.isReady = function ()
{
    if (this.outputStream != null)
        return true;
    else
        return false;
}
//******************************************************************************
CServerInterface.prototype.sendData = function (data)
{
    /*privMan.enablePrivilege (privList);*/

    this.outputStream.send(data);
}
export { CServerInterface };
